import React from 'react';
import PillAnchor from './PillAnchor';


export const PillNavigation: React.FC = () => {
  return (
    <div className="bg-ii-white rounded-60px shadow-learning-center-navigation w-full flex items-center overflow-hidden">
      <PillAnchor text="Toolkits" url="/learningcenter/toolkits/" />
      <div className="lg:h-learning-center-navigation h-learning-center-navigation-mobile w-px bg-ii-seperator" />
      <PillAnchor text="Resources" url="/learningcenter/resources/" />
    </div>);
};



